<script>
  export let group = undefined;
	export let value = undefined;
    
</script>

<div class="py-5 border-b-2 hover:shadow-lg px-2 rounded-lg optionaddress" id="optionaddress-{value}" style="display:block"> 
                <label
                  for="label-{value}"
                  class="text-sm font-light relative flex  cursor-pointer">
                  {#if group==value}
                  <input
                    type="radio"
                    name="option"
                    id="label-{value}" bind:group value={value} on:click
                    class="form-checkbox text-3xl mr-2" checked/>
                    {:else}
                    <input
                      type="radio"
                      name="option"
                      id="label-{value}" bind:group value={value} on:click
                      class="form-checkbox text-3xl mr-2" />
                    {/if}
               <slot />
                </label>
              </div>